import { createTypes } from 'redux-compose-reducer';
import { post } from 'utils/apiRequester';
import { clearConversations } from 'actions/conversations';


export const TYPES = createTypes('auth', [
  'logIn',
  'logOut',
  'switchEnvBaseUrl'
]);


export function suLogIn(dispatch, data) {
  return post('/admin/login', data)
    .then(({ data }) => {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');

      localStorage.setItem('admin', JSON.stringify(data.admin));
      localStorage.setItem('suAccessToken', data.accessToken);
      return dispatch({
        type: TYPES.logIn,
        suAccessToken: data.accessToken,
        admin: data.admin
      });
    })
    .catch(e => {
      throw e;
    });
}

export function logIn(dispatch, data) {
  return post('/api/user/auth-local', data)
    .then(({ data }) => {
      localStorage.setItem('accessToken', data.accessToken);
      localStorage.setItem('refreshToken', data.refreshToken);
      localStorage.setItem('user', JSON.stringify(data.user));

      if (data.user.type !== 'psychic') {
        logOut(dispatch);
        history.push('/login');
      } else {
        return dispatch({
          type: TYPES.logIn,
          accessToken: data.accessToken,
          refreshToken: data.refreshToken,
          user: data.user
        });
      }
    })
    .catch(e => {
      throw e;
    });
}

export function internalLogIn(dispatch, accessToken, suAccessToken, user, admin) {
  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('user', JSON.stringify(user));
  clearConversations(dispatch);
  return dispatch({
    type: TYPES.logIn,
    accessToken,
    suAccessToken,
    user,
    admin
  });
}

export function internalLogOut() {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('user');
}

export function logOut(dispatch) {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('suAccessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');
  localStorage.removeItem('admin');
  dispatch({
    type: TYPES.logOut
  });
}

export function switchEnvBaseUrl(history, envBaseUrl) {
  localStorage.setItem('envBaseUrl', envBaseUrl);
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');
  history.push('/psychics');
  window.location.reload();
}


export function authError(dispatch, err, history, throwError = true, fullLogout = true) {
  if (err.response && err.response.status === 401) {
    const suAccessToken = localStorage.getItem('suAccessToken');

    if (!fullLogout && suAccessToken) {
      internalLogOut();
      history.push('/psychics');
    } else {
      logOut(dispatch);
      history.push('/login');
    }
  } else {
    if (throwError) {
      throw err;
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth.js